export default __webpack_public_path__ + "static/media/logoDDark.2d0fbc37.png";